import React from 'react';
import { useBlock } from './SiteContent';

const DEFAULT = {
  currency: 'BYN',
  items: [
    { name: 'Оффлайн консультация', price: 120, duration: '50 минут', note: 'Минск' },
    { name: 'Онлайн-сессия', price: 90, duration: '50 минут', note: 'Zoom / Telegram' },
    { name: 'Ознакомительная консультация', price: 50, duration: '50 минут', note: 'первая встреча' },
  ],
};

export default function Pricing() {
  const p = useBlock('pricing', DEFAULT);
  const items = p.items?.length ? p.items : DEFAULT.items;
  const currency = p.currency || 'BYN';
  return (
    <section id="pricing" className="py-16 md:py-24 bg-cream" data-testid="pricing">
      <div className="max-w-4xl mx-auto px-5 md:px-8">
        <div className="reveal text-center mb-10">
          <div className="flex items-center justify-center gap-3 mb-4 text-[12px] tracking-[0.24em] uppercase text-wine/70">
            <span className="gold-divider" />
            <span>стоимость</span>
            <span className="gold-divider" />
          </div>
          <h2 className="font-heading text-3xl md:text-[44px] text-ink leading-tight">
            Прозрачно и&nbsp;без пакетов
          </h2>
        </div>

        <div className="divide-y divide-ink/10 border-y border-ink/15">
          {items.map((it, i) => (
            <div
              key={it.id || it.name || i}
              className="reveal flex flex-col sm:flex-row sm:items-end sm:justify-between gap-3 py-6 md:py-7"
              style={{ transitionDelay: `${i * 50}ms` }}
              data-testid={`pricing-row-${i}`}
            >
              <div>
                <div className="font-heading text-xl md:text-2xl text-ink">{it.name}</div>
                <div className="text-sm text-ink/55 mt-1">
                  {[it.duration, it.note].filter(Boolean).join(' · ')}
                </div>
              </div>
              <div className="font-heading text-3xl md:text-4xl text-wine">
                {it.price} <span className="text-base text-ink/55 align-middle">{currency}</span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
